export default "<app-common-product-rule-template [viewtoEditLastChild] = \"viewtoEditLastChild\"></app-common-product-rule-template>\n";